import { render, staticRenderFns } from "./CucReport.vue?vue&type=template&id=b14bf406&scoped=true&"
import script from "./CucReport.vue?vue&type=script&lang=js&"
export * from "./CucReport.vue?vue&type=script&lang=js&"
import style0 from "./CucReport.vue?vue&type=style&index=0&id=b14bf406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14bf406",
  null
  
)

export default component.exports